module.exports = __webpack_public_path__ + "static/media/switch-friend1.debaf0a2.png";